import type { CellValue, Rows } from '../../Components/PRMTable/PRMTableType';
import type { Account } from '../accountsTypes';
import { columns } from '../accountsTableConfig';
import type { AccountsFilterValues } from './AccountsFilterTypes';
import { categoryOptions } from '../../constants/accounts/categoryOptions';

const getFilterValues = (record: Record<string, CellValue>, key: string): string[] => {
  const column = columns.find((item) => item.key === key);
  const fields = column?.chips?.length ? column.chips.map((source) => source.field) : [key];

  return fields
    .flatMap((field) => {
      const value = record[field];
      if (value == null) return [];

      const values = Array.isArray(value) ? value.map(String) : [String(value)];
      return values.flatMap((item) => (column?.chips?.length || key === 'confirmedBrands' ? item.split(',') : [item]));
    })
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getFilterOptions = (records: Rows['data'], key: string): string[] =>
  key === 'category'
    ? categoryOptions
    : Array.from(new Set(records.flatMap((record) => getFilterValues(record, key)))).sort((a, b) => a.localeCompare(b));

export const filterAccounts = (records: Account[], selections: AccountsFilterValues, searchTerm = ''): Account[] => {
  const search = searchTerm.trim().toLowerCase();

  return records.filter(
    (account) =>
      account.companyName.toLowerCase().includes(search) &&
      Object.entries(selections).every(([key, selectedValue]) => {
        const selectedValues = (Array.isArray(selectedValue) ? selectedValue : [selectedValue]).filter(Boolean);
        if (!selectedValues.length) return true;

        const values = getFilterValues(account, key);
        return selectedValues.some((value) => values.includes(value));
      }),
  );
};
